import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Form, Field } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class Edit extends React.Component {
	@observable record = null;
	@observable error = null;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		if (this.id) {
			try {
				this.record = await store.model.Division.findById(this.id);
			} catch (e) {
				this.error = e.message;
			}
		} else {
			this.record = new store.model.Division();
		}
	};

	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;

		return (
			<>
				<p>Избирательный округ</p>
				<Form record={this.record} rootPath="/admin" returnTo="/admin/divisions" noDelete>
					<Field property="number" label="Номер" />
					<Field property="name" label="Наименование" />
					<Field relation="group" property="name" label="Группа" />
				</Form>
			</>
		);
	}
}
